import { v4 as uuid } from 'uuid';
import { task as taskEndpoints } from '../../api/endpoints';

export const TASK_GET = 'TASK_GET';
export const TASK_GET_SUCCESS = 'TASK_GET_SUCCESS';
export const TASK_UPDATE = 'TASK_UPDATE';
export const TASK_UPDATE_SUCCESS = 'TASK_UPDATE_SUCCESS';
export const TASK_RELEASE = 'TASK_RELEASE';
export const TASK_RELEASE_SUCCESS = 'TASK_RELEASE_SUCCESS';
export const TASK_FORM_GET = 'TASK_FORM_GET';
export const TASK_FORM_GET_SUCCESS = 'TASK_FORM_GET_SUCCESS';
export const TASK_ANSWER = 'TASK_ANSWER';
export const TASK_ANSWER_SUCCESS = 'TASK_ANSWER_SUCCESS';
export const TASK_FORM_KEEP = 'TASK_FORM_KEEP';
export const TASK_FORM_KEEP_SUCCESS = 'TASK_FORM_KEEP_SUCCESS';
export const TASK_SUPPORTED_ALLOCATION = 'TASK_KEEP_ALLOCATION';
export const TASK_SUPPORTED_ALLOCATION_SUCCESS = 'TASK_SUPPORTED_ALLOCATION_SUCCESS';
export const ANSWER_REMOVE_FIELD = 'ANSWER_REMOVE_FIELD';
export const ANSWER_REMOVE_BLOCK = 'ANSWER_REMOVE_BLOCK';
export const ANSWER_SET_AUTOFOCUS_ROW = 'ANSWER_SET_AUTOFOCUS_ROW';


export const getTask = (projectId, isReview, meta = {}) => ({
  type: TASK_GET,
  fetch: { ...taskEndpoints.getTask(projectId, isReview), auth: true },
  meta: { requestId: uuid(), ...meta },
});

export const getFormTask = (formId) => ({
  type: TASK_FORM_GET,
  fetch: { ...taskEndpoints.getForm(formId), auth: true },
  meta: { requestId: uuid() },
});

export const createTaskAnswer = (taskId, supportDateTime, duration, json, meta = {}) => ({
  type: TASK_ANSWER,
  fetch: {
    ...taskEndpoints.createAnswer(taskId, supportDateTime, duration, json),
    auth: true,
  },
  meta: { requestId: uuid(), ...meta },
});

export const updateMarkTask = (values) => {
  return {
    type: TASK_UPDATE,
    fetch: { ...taskEndpoints.updateMark(values), auth: true },
    meta: { requestId: uuid() },
  };
};

export const releaseTask = (taskId, meta = {}) => ({
  type: TASK_RELEASE,
  fetch: { ...taskEndpoints.release(taskId), auth: true },
  meta: { requestId: uuid(), ...meta },
});

export const keepTask = (taskId, meta = { taskId }) => ({
  type: TASK_FORM_KEEP,
  fetch: { ...taskEndpoints.keep(taskId), auth: true },
  meta: { requestId: uuid(), ...meta },
});

export const answerRemoveField = (fieldPath) => ({
  type: ANSWER_REMOVE_FIELD,
  payload: { fieldPath },
});

export const answerRemoveBlock = (blockPath) => ({
  type: ANSWER_REMOVE_BLOCK,
  payload: { blockPath },
});

// Path of the row the user just added/inserted. The first focusable
// field of that row reads it to focus itself, then clears it.
export const setAutoFocusRow = (rowPath) => ({
  type: ANSWER_SET_AUTOFOCUS_ROW,
  payload: { rowPath },
});

export const clearAutoFocusRow = () => ({
  type: ANSWER_SET_AUTOFOCUS_ROW,
  payload: { rowPath: null },
});
